import React, { useState, useRef, useMemo, useEffect } from "react";
import "./ParamConfidentialite.scss";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import BtnEcouteMarche from "Components/Boutons/BtnEcouteMarche/BtnEcouteMarche";
import { Controller } from "react-hook-form";
import { classNames } from "primereact/utils";
import { Checkbox } from "primereact/checkbox";
import { Divider } from "primereact/divider";
import NavBarTab from "Components/NavBar/NavBarTab/NavBarTab";
import { updateAuth } from "Redux/Actions/authActions";
import axios from "axios";
import BtnBleuLeft from "Components/Boutons/BtnBleuLeft/btn-bleu-left";
import { FaCheck } from "react-icons/fa";
import { Toast } from "primereact/toast";
import BtnRetour from "Components/Boutons/BtnRetour/btn-retour";
import Modal from "Components/Modal/Modal";
import BtnBlanc from "Components/Boutons/BtnBlanc/btn-blanc";

const ParamConfidentialite = (props) => {
  // eslint-disable-next-line no-unused-vars
  const [formData, setFormData] = useState({});
  const successUpdate = useRef(null);

  // Popup validation charte
  const [visibleModal, setVisibleModal] = useState(false);

  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
    watch,
  } = useForm({
    defaultValues: useMemo(() => {
      return {
        ...props.auth.userConnected,
      };
    }, [props.auth.userConnected]),
  });
  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  useEffect(() => {}, [watch("charteSigned")]);

  /**
   * Fonction qui va créer un lien de téléchargement de la charte
   *
   * Une fois le lien cliqué, la charte sera téléchargée
   *
   * Nom du fichier : charteRP.pdf
   */
  const downloadCharter = () => {
    //? Création de l'url de l'api
    let url = `${process.env.REACT_APP_BASE_URL_API}/charter/pdf`;
    //? Appel de l'api
    axios
      .get(url, {
        headers: {
          Authorization: `Bearer ${props.auth.token}`,
          accept: "application/json",
        },
        responseType: "blob",
      })
      //? En cas de succès, création du lien de téléchargement
      .then((res) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(res.data);
        link.target = "_blank";
        link.setAttribute("download", `charteRP.pdf`);
        link.click();
      })
      //? En cas d'erreur, affichage de l'erreur
      .catch((error) => {
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        });
      });
  };

  const putDataToApi = (data) => {
    //? Remove id de l'objet props.user
    const userObj = { ...data };
    const { charteSigned, newsLetterNotification, datasVisibleForAllMembers } =
      userObj;
    const newParamsConfidential = {
      charteSigned,
      newsLetterNotification,
      datasVisibleForAllMembers,
    };
    axios
      .put(
        `${process.env.REACT_APP_BASE_URL_API}/users/${props.auth.userConnected.id}`,
        newParamsConfidential,
        {
          headers: props.auth.token
            ? {
                accept: "application/json",
                "Content-Type": "application/json",

                Authorization: `Bearer ${props.auth.token}`,
              }
            : {
                accept: "application/json",
                "Content-Type": "application/json",
              },
        }
      )
      .then((res) => {
        if (res.status === 200) {
          showSuccess();
          props.handleUpdateAuth({ userConnected: res.data });
        }
      })
      .catch((error) =>
        props.auth.toast?.current?.show({
          severity: "error",
          summary: "Erreur",
          detail: error?.response?.data?.detail || "Une erreur est survenue",
          life: 5000,
        })
      );
  };

  const showSuccess = () => {
    successUpdate.current.show({
      severity: "success",
      summary: "Mise à jour effectuée avec succès",
      detail: "Votre mise à jour a bien été prise en compte",
      life: 3000,
    });
  };

  const onSubmit = (data) => {
    setFormData(data);
    putDataToApi(data);
  };
  return (
    <div>
      <Toast ref={successUpdate} />
      {props.auth.isConnected && (
        <div className="article_actu">
          <NavBarTab
            id="desktop"
            select="profiledit"
            activeIndex={props.activeIndex}
            items={props.items}
          />
          <BtnEcouteMarche items={props.items} />

          <div className="titre_de_page">
            <h1 className="h1_trait_dessus">
              Modifier mes {props.items[props.activeIndex].label}
            </h1>
            <BtnRetour />
          </div>
          <div className="form-demo">
            <div className="flex justify-content-center">
              <div className="card">
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                  <Divider>
                    <span className="p-tag">Accessibilité du profil</span>
                  </Divider>
                  <div className="field-checkbox">
                    <Controller
                      name="datasVisibleForAllMembers"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Checkbox
                          inputId={field.name}
                          onChange={(e) => field.onChange(e.checked)}
                          checked={field.value}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    <label
                      htmlFor="datasVisibleForAllMembers"
                      className={classNames({ "p-error": errors.accept })}
                    >
                      Accessible aux membres Réseau Pro
                    </label>
                    {getFormErrorMessage("name")}
                  </div>
                  <Divider>
                    <span className="p-tag">Newsletter</span>
                  </Divider>
                  <div className="field-checkbox">
                    <Controller
                      name="newsLetterNotification"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Checkbox
                          inputId={field.name}
                          onChange={(e) => field.onChange(e.checked)}
                          checked={field.value}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    <label
                      htmlFor="newsLetterNotification"
                      className={classNames({ "p-error": errors.accept })}
                    >
                      Recevoir la newsletter de Réseau Pro
                    </label>
                    {getFormErrorMessage("name")}
                  </div>
                  <Divider>
                    <span className="p-tag">Charte du site</span>
                  </Divider>

                  <div className="field-checkbox">
                    <Controller
                      name="charteSigned"
                      control={control}
                      render={({ field, fieldState }) => (
                        <Checkbox
                          inputId={field.name}
                          onChange={(e) => {
                            field.onChange(!e.checked);
                            if (e.checked) setVisibleModal(true);
                          }}
                          checked={!field.value}
                          className={classNames({
                            "p-invalid": fieldState.invalid,
                          })}
                        />
                      )}
                    />
                    <label
                      htmlFor="charteSigned"
                      className={classNames({ "p-error": errors.accept })}
                    >
                      Refuser la charte et ne plus faire partie de Réseau Pro
                    </label>
                    {getFormErrorMessage("name")}
                  </div>

                  <div>
                    <span
                      className="charter_link"
                      onClick={() => downloadCharter()}
                    >
                      Télécharger la charte du site
                    </span>
                  </div>

                  {visibleModal && (
                    <Modal
                      visible={visibleModal}
                      setVisible={setVisibleModal}
                      header="Êtes-vous sûr ?"
                    >
                      <div className="modal_description_charte">
                        <form action="/action_page.php" className="form_charte">
                          {/* <label htmlFor="fname">First name:</label> */}
                          {/* <input type="text" id="fname" name="fname" value="John" /> */}
                          <label className="charte_modal">
                            Vous ne pourrez plus revenir en arrière
                          </label>
                        </form>
                      </div>

                      <div className="boutons_modal">
                        <BtnBlanc
                          btnAction={() => setVisibleModal(false)}
                          btnTexte="Continuer"
                        />
                        <BtnBlanc
                          btnTexte="Annuler"
                          btnAction={() => {
                            setVisibleModal(false);
                            setValue("charteSigned", true);
                          }}
                        />
                      </div>
                    </Modal>
                  )}

                  <div className="form_columns submit">
                    <BtnBleuLeft btnTexte="Enregistrer ">
                      <FaCheck />
                    </BtnBleuLeft>
                    {/* <button type="submit" label="Submit"></button> */}
                    {/* <BtnBlanc
                      btnTexte="Modifier "
                      btnAction={() => (window.location.href = "/#")}
                    >
                      <FaPen />
                    </BtnBlanc> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

ParamConfidentialite.propTypes = {
  auth: PropTypes.object,
  admin: PropTypes.object,

  items: PropTypes.array,
  activeIndex: PropTypes.number,
  handleUpdateAuth: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  admin: state.admin,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateAuth: (value) => {
    dispatch(updateAuth(value));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ParamConfidentialite);
